import { FooterData } from './footerState'
import { HttpResult } from 'widgets-for-react'

export const footerApi = async (): Promise<HttpResult<FooterData>> => {
  // From Spaarne rebuild
  const res = await fetch('/api/v1/lists/footer');

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: FooterData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: data.map(d => ({ ...d, Items: d.Items.sort((a, b) => a.Order - b.Order) })),
  }
}
